import { analytics } from '@/utils/analytics';
import { EventProperties } from '@asurion-core/analytics-core';
import { SegmentEvents } from './types';

/*
  Function that wraps the track function from the analytics-core package.
  This allows D2C to only specify events from the SegmentEvents and
  Non-SegmentEvents enums and not allow arbitrary event names as strings.
  We also add the SkipMixpanel flag for Segment events since they have PII.
  For a subset of those we create "shadow" events that don't have the Customer
  property and send those to MixPanel.
*/
export const trackD2CSegmentAnalytics = async (
  eventName: SegmentEvents,
  payload: EventProperties,
) => {
  // Make a deep copy of the payload without the PII and append NoPII to the event name
  // so we can get clean version to MixPanel.
  const payloadWithoutPII = structuredClone(payload);
  delete payloadWithoutPII.ExtraData?.Customer;
  delete payloadWithoutPII.ExtraData?.Email;
  payloadWithoutPII.Name = `${eventName}_NoPII`;
  analytics.track(payloadWithoutPII.Name, payloadWithoutPII);

  // Segment events need to have PII, so don't send them to MixPanel
  // Now set the SkipMixpanel flag for sending the original event.
  // We do this second since the MetaData is shared between both the copied
  // payload and the original.
  const { MetaData = {} } = payload;
  MetaData.SkipMixpanel = true;
  payload.MetaData = MetaData;
  analytics.track(eventName, payload);
};
